export default async function animationEnds(target: HTMLElement | HTMLElement[]): Promise<void> {
	// A single root waits for EVERY animation in its subtree; a list of elements waits only for
	// those elements' OWN animations (no descendants). The list form lets a caller await a specific
	// transition without also awaiting unrelated animations nested inside it — e.g. an open dropdown
	// whose `finished` promise may never settle, which would otherwise hang the caller forever.
	const animations = Array.isArray(target)
		? target.flatMap(element => element.getAnimations())
		: target.getAnimations({subtree: true});

	// Skip infinite animations (e.g. loading spinners): their `finished` promise never resolves,
	// so awaiting them would hang the caller forever. Only finite animations can ever signal
	// "the animation ended".
	const finite = animations.filter(a => a.effect?.getComputedTiming().iterations !== Infinity);
	await Promise.allSettled(finite.map(a => a.finished));
}
